import { render, staticRenderFns } from "./ContainerView.vue?vue&type=template&id=937b10b8"
import script from "./ContainerView.vue?vue&type=script&lang=js"
export * from "./ContainerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports